import { isMobileScreen } from './utils';
import { BREAKPOINTS } from './constants';
import { dropdownHandler } from './dropdown';
import { tabsHandler } from './tabs';

const onTabDropdownSelect = (value, leadershipOptions) => leadershipOptions.forEach((item) => {
  item.getAttribute('data-tabs-item-value') === value ?
    item.classList.remove('hidden') : item.classList.add('hidden');
});

const setTabsHeight = (options, item) => {

  let maxHeight = 0;
  Array.from(options).forEach((child) => {
    const childHeight = child.clientHeight;
    if (childHeight > maxHeight) {
      maxHeight = childHeight;
    }
  });

  Array.from(options)?.forEach((child) => {
    child.style.height = `${maxHeight}px`;
  });

  const tabs = item.querySelector('[data-tabs]');
  const nextElement = item.querySelector('.section_left_banner');
  tabsHandler(tabs, nextElement, (value) => onTabDropdownSelect(value, options));
};

const onTabsContainerLoad = () => {
  const tabsContainers = document.querySelectorAll('[data-tabs-container]');

  if (!tabsContainers.length) return;

  tabsContainers?.forEach((item) => {
    const options = item.querySelectorAll('[data-tabs-item-value]');

    if (isMobileScreen(BREAKPOINTS.MD)) {
      const dropdown = item.querySelector('[data-dropdown]');
      dropdownHandler(dropdown, (value) => onTabDropdownSelect(value, options));
      return;
    }

    const timeout = setTimeout(() => {
      setTabsHeight(options, item);
      clearTimeout(timeout);
    }, 1200);
  });

};

export default onTabsContainerLoad;
